import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import StateBar from '../../StateBar';
import Gauge, { GaugeItem } from '../../Gauge';
import { useContactsQuery } from 'core/api/contacts';
import ContactStatus from 'core/enums/contactStatus';
import { computeContactIconAndColorStatus } from '../ContactStatus';

const ContactStateBar: FC = () => {
    const { t } = useTranslation();
    const { data: contactsData } = useContactsQuery();
    const contacts = useMemo(() => contactsData ?? [], [contactsData]);

    const statusOrder = [ContactStatus.Incomplete, ContactStatus.New, ContactStatus.Engaged, ContactStatus.Thanked];

    const items: GaugeItem[] = statusOrder
        .map((label: ContactStatus) => ({
            label: t(`common.contact-status.enum.${label}`),
            ...computeContactIconAndColorStatus(label),
            count: contacts.filter((contact) => label === contact.status).length,
        }))
        .filter((item: GaugeItem) => item.count);

    return (
        <StateBar title={t('contact-state-bar.title')}>
            <Gauge items={items} />
        </StateBar>
    );
};

export default ContactStateBar;
